import React from "react";
import { Send } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
export default function ReadyToChangeALife() {
  return <section data-section-id="242486" id="ready-to-change-a-life" className="relative w-full overflow-hidden dark bg-primary py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-[10%] -top-[20%] h-[60%] w-[60%] rounded-lg bg-secondary/20 blur-[120px]" />
        <div className="absolute -bottom-[20%] -right-[10%] h-[60%] w-[60%] rounded-lg bg-white/10 blur-[120px]" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-24">
          {}
          <div className="flex flex-col gap-6 text-center lg:text-left">
            <h2 className="font-default text-4xl font-black tracking-tighter text-white sm:text-5xl md:text-6xl">
              Ready to change a life today?
            </h2>
            <p className="font-default text-lg text-white/90 md:text-xl">
              Your contribution provides clean water, education, and medical care to communities in need. Join our global family of supporters.
            </p>
            <div className="mt-4 flex flex-col gap-4 sm:flex-row sm:justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-sm font-bold text-white">
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/20 text-white">
                  1
                </div>
                <span>Choose Amount</span>
              </div>
              <div className="hidden h-px w-8 bg-white/20 sm:block sm:self-center" />
              <div className="flex items-center gap-2 text-sm font-bold text-white">
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/20 text-white">
                  2
                </div>
                <span>Select Frequency</span>
              </div>
              <div className="hidden h-px w-8 bg-white/20 sm:block sm:self-center" />
              <div className="flex items-center gap-2 text-sm font-bold text-white">
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/20 text-white">
                  3
                </div>
                <span>Impact Lives</span>
              </div>
            </div>
          </div>

          {}
          <div className="mx-auto w-full max-w-md lg:mx-0 lg:max-w-none">
            <Card className="relative overflow-hidden border-white/10 bg-white/10 shadow-4xl backdrop-blur-xl">
              {}
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/10 to-transparent" />
              
              <CardHeader className="relative z-10 pb-4 pt-12 text-center">
                <div className="mx-auto mb-6 flex h-28 w-28 items-center justify-center rounded-3xl bg-gradient-to-br from-white/20 to-white/5 p-1 shadow-lg">
                  <div className="flex h-full w-full items-center justify-center rounded-2xl bg-white/10 p-4 backdrop-blur-md">
                    <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/foundation_impact_icon.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/foundation_impact_icon.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/foundation_impact_icon.png-wvc-sizes" alt="Helping Hands Foundation Impact" className="h-full w-full object-contain brightness-0 invert" loading="lazy" />
                  </div>
                </div>
                <CardTitle className="font-default text-3xl font-bold text-white">
                  Make a Donation
                </CardTitle>
                <CardDescription className="font-default mt-3 text-base text-white/80">
                  100% of your donation goes directly to field projects and community development.
                </CardDescription>
              </CardHeader>
              
              <CardContent className="relative z-10 flex justify-center pb-12 pt-6">
                <Button size="lg" className="h-14 rounded-lg bg-[#FFD700] px-10 text-lg font-bold text-primary shadow-xl transition-transform hover:scale-105 hover:bg-[#FFD700]/90" asChild>
                  <Link to="/GetInvolvedPage">
                    <Send className="mr-2 h-5 w-5" />
                    Complete Donation
                  </Link>
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}